import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { OperatorMaps } from './types';
import { equal, notEqual } from './Operators/equal';
import { lessThan, lessThanOrEqualTo } from './Operators/lessThan';
import { greaterThan, greaterThanOrEqualTo } from './Operators/greaterThan';
import { stringStartsWith } from './Operators/stringStartsWith';
import { inCollection, notInCollection } from './Operators/collection';

/**
 * Mapping object to map the supported Operators to their defining function
 */
export const operatorMaps: OperatorMaps<DispatchLeg> = {
	'=': equal,
	'!=': notEqual,
	'>': greaterThan,
	'>=': greaterThanOrEqualTo,
	'<': lessThan,
	'<=': lessThanOrEqualTo,
	in: inCollection,
	notIn: notInCollection,
	startsWith: stringStartsWith
};
